enum EQuizQuestionType {
	checkbox = 'checkbox',
	radio = 'radio'
}

enum EQuizAnswerStatus {
	unset = 'unset',
	correct = 'correct',
	incorrect = 'incorrect'
}

export { EQuizQuestionType, EQuizAnswerStatus };
